<form>
  <div class="row">
    <div class="col-md-12 col-xl-12">
      <div class="table-responsive our-table">
        <table class="table table-striped text-nowrap mb-0">
          <thead class="border-top">
            <tr>
              <th scope="col" class="text-capitalize">Data de Registro</th>
              <th scope="col" class="text-capitalize">Última Transação</th>
              <th scope="col" class="text-capitalize">Documento</th>
              <th scope="col" class="text-capitalize">Nome</th>
              <th scope="col" class="text-capitalize">ID Usuário</th>
              <th scope="col" class="text-capitalize">Produto</th>
              <th scope="col" class="text-capitalize">Operador</th>
              <th scope="col" class="text-capitalize">Email</th>
              <th scope="col" class="text-capitalize text-center">Status</th>
            </tr>
          </thead>

          <tbody>
            <tr class="border-bottom" *ngFor="let transaction of transactions">
              <td>
                <span>{{ transaction.createAtView }}</span>
              </td>
              <td>
                <span>{{ transaction.updateAtView }}</span>
              </td>
              <td>
                <span>
                  {{
                    transaction.document
                      | mask
                        : ((transaction.document?.length || 0) > 11
                            ? "CPF_CNPJ"
                            : "CPF_CNPJ")
                  }}
                </span>
              </td>

              <td>
                <span>{{ transaction.name }}</span>
              </td>
              <td>
                <span>{{ transaction.userId }}</span>
              </td>
              <td>
                <span>{{ transaction.productId }}</span>
              </td>
              <td>
                <span>{{ transaction.accountId }}</span>
              </td>
              <td>
                <span>{{ transaction.email }}</span>
              </td>

              <td class="align-middle text-center">
                <label class="custom-switch">
                  <input
                    type="checkbox"
                    class="custom-switch-input"
                    [checked]="transaction.active"
                    (click)="openToggleModal(transaction, $event)"
                  />
                  <span class="custom-switch-indicator"></span>
                </label>
              </td>
            </tr>

            <tr *ngIf="transactions.length === 0">
              <td colspan="9">
                {{ "common.noData" | translate }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="d-flex justify-content-between p-2">
        <ngb-pagination
          [collectionSize]="total"
          [maxSize]="5"
          [rotate]="true"
          [(page)]="page"
          [pageSize]="pageSize"
          (pageChange)="pageChange()"
        >
        </ngb-pagination>
      </div>
    </div>
  </div>
</form>

<ng-template #requestPassword let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Informe a senha</h5>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    ></button>
  </div>

  <div class="modal-body">
    <div class="form-group mt-2">
      <p *ngIf="errorMessage.length > 0" class="text-danger">
        {{ errorMessage }}
      </p>
    </div>

    <div class="form-group mb-3">
      <input
        type="text"
        class="form-control"
        id="authToken"
        placeholder="Senha"
        [(ngModel)]="passwordInsert"
        (keyup.enter)="confirmToggle()"
      />

      <button
        (click)="pasteTotpCode()"
        class="btn btn-primary btn-block btn-colar h-30 w-30 mx-auto mt-2 mb-1"
      >
        {{ "login.totp.pasteButton" | translate }}
      </button>
    </div>
  </div>

  <div class="modal-footer text-center">
    <button
      type="submit"
      class="btn btn-lg btn-primary btn-pill mx-auto d-block"
      (click)="confirmToggle()"
      [disabled]="validatingPassword"
    >
      VALIDAR
    </button>
  </div>
</ng-template>
